
import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';
import { CardItem } from '@/components/admin/cards/CardForm';
import { transformDatabaseCard } from '@/types/insight';

export const useCardData = () => {
  const [cards, setCards] = useState<CardItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch cards from Supabase on component mount
  useEffect(() => {
    const fetchCards = async () => {
      try {
        setIsLoading(true);
        
        // Check if we can access the Supabase table
        const { data: dbCards, error } = await supabase
          .from('insight_cards')
          .select('*, card_insights(id, insight_text)')
          .order('created_at', { ascending: false });
        
        if (error) {
          console.error('Error fetching from Supabase:', error);
          throw error;
        }
        
        // Transform data to match CardItem interface
        if (dbCards && dbCards.length > 0) {
          const transformedCards = dbCards.map(card => transformDatabaseCard(card)) as CardItem[];
          setCards(transformedCards);
        } else {
          // Fallback to localStorage if no data in Supabase yet or during migration
          const storedCards = localStorage.getItem('insightCards');
          if (storedCards) {
            setCards(JSON.parse(storedCards));
          } else {
            setCards([]);
          }
        }
      } catch (error) {
        console.error('Error fetching cards:', error);
        toast.error('Failed to load insight cards');
        
        // Fallback to localStorage
        const storedCards = localStorage.getItem('insightCards');
        if (storedCards) {
          setCards(JSON.parse(storedCards));
        } else {
          setCards([]);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchCards();
  }, []);

  return {
    cards,
    setCards,
    isLoading
  };
};
